import { lazy, Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import TanstackProvider from "context/TanstackProvider";
import MyI18NextProvider from "context/MyI18NextProvider";
import MyThemeProvider from "context/theme/MyThemeProvider";

const ProtectedRoute = lazy(() => import("./layout/ProtectedRoute.jsx"));

const App = () => {
  return (
    <MyThemeProvider>
      <MyI18NextProvider>
        <TanstackProvider>
          <Router>
            <Suspense>
              <ProtectedRoute />
            </Suspense>
          </Router>
        </TanstackProvider>
      </MyI18NextProvider>
    </MyThemeProvider>
  );
};

export default App;
